import { MsalAuthenticationTemplate } from "@azure/msal-react"
import { Helmet } from "react-helmet"
import Header from "../../../components/header"
import Navbar from "../../../components/NavBar"
import { InteractionType } from "@azure/msal-browser"
import { loginRequest } from "../../../auth/AuthConfig"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import React, { useEffect } from "react";
import { ListSummaryDTO } from "../types/ftp_automation_types";
import { fetchListSummaries } from "../api/listSummariesAPI";
import '../../../styles/dashboardStyles.css';

function ListSummaryPage() {

    const [data, setData] = React.useState<ListSummaryDTO[] | null>(null);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [error, setError] = React.useState<string | null>(null);

    useEffect(() => {
        const controller = new AbortController();
        (async () => {
            try {
                setLoading(true);
                setError(null);
                const rows = await fetchListSummaries(controller.signal);
                setData(rows);
            } catch (e: any) {
                setError(e?.message ?? "Failed to load data");
            } finally {
                setLoading(false);
            }
        })();
        return () => controller.abort();
    }, []);

    const onEdit = (row: ListSummaryDTO) => {
        console.log("Edit clicked:", row);
    };

    return (
        <>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={loginRequest}
            >
                <div className="full-height-form p-fluid">
                    <Helmet>
                        <title>FTP Automation Setup</title>
                    </Helmet>
                    <Header />
                    <Navbar />
                    <h1 className='Ph1'>FTP Automation Jobs</h1>

                    <div className="data-table-section p-grid">


                            {error && (
                                <div className="p-message p-component p-message-error mb-3">
                                    <span className="p-message-icon pi pi-times-circle" />
                                    <span className="p-message-text">{error}</span>
                                </div>
                            )}

                            <DataTable
                                value={data ?? []}
                                loading={loading}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 20, 50]}
                                stripedRows
                                sortMode="multiple"
                                emptyMessage={loading ? "Loading…" : "No records found."}
                                dataKey="listId"
                                responsiveLayout="scroll"
                            >

                                <Column field="listCode" header="Job Group" sortable />
                                <Column field="listName" header="Description" sortable />
                                <Column
                                    field="isActive"
                                    header="Active"
                                    sortable
                                    body={(row) => (row.isActive ? "Yes" : "No")}
                                    style={{ width: "8rem" }}
                                />
                                <Column field="sourcesCount" header="Jobs" sortable style={{ width: "8rem" }} />
                                <Column
                                    header="Actions"
                                    body={(row) => (
                                        <Button label="Edit" severity="success" icon="pi pi-pencil" size="small" onClick={() => onEdit(row)} />
                                    )}
                                    style={{ width: "8rem" }}
                                />
                            </DataTable>
                        </div>
                    </div>

            </MsalAuthenticationTemplate>

        </>

    )
}

export default ListSummaryPage